<script>
  import {cn} from "$lib/utils.js";
  import Header from "./bits/calendar-header.svelte";

  let {ref = $bindable(null), class: className, ...restProps} = $props();
</script>

<Header
  bind:ref
  class={cn("relative flex w-full items-center justify-between pt-1", className)}
  {...restProps}
/>
